var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90567 4.17749L4.6665 14.8133C4.74705 15.3002 4.99783 15.7427 5.37417 16.062C5.75052 16.3813 6.22798 16.5566 6.7215 16.5567H9.5115M15.0932 4.17749L13.3332 14.8133C13.2526 15.3002 13.0018 15.7427 12.6255 16.062C12.2492 16.3813 11.7717 16.5566 11.2782 16.5567H8.48817M7.3515 8.26332V12.4708M10.6482 8.26332V12.4708M1.2915 4.17749H16.7082M11.314 4.17749V2.69415C11.314 2.36263 11.1823 2.04469 10.9479 1.81027C10.7135 1.57585 10.3955 1.44415 10.064 1.44415H7.93567C7.60415 1.44415 7.28621 1.57585 7.05179 1.81027C6.81737 2.04469 6.68567 2.36263 6.68567 2.69415V4.17749H11.314Z",
    stroke: "#E22121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.8cafdab5fef3592f1e3dba2edbcdd0b6.svg";
export { ForwardRef as ReactComponent };